export enum StringBoolean {
  TRUE = 'true',
  FALSE = 'false',
}

export const stringBooleanToBoolean = (stringBoolean: string): boolean => {
  return stringBoolean === StringBoolean.TRUE;
};

export const booleanOrUndefinedToStringBooleanOrUndefined = (
  value: boolean | undefined = undefined,
): StringBoolean | undefined => {
  return value !== undefined ? booleanToStringBoolean(value) : undefined;
};

export const booleanToStringBoolean = (boolean: boolean): StringBoolean =>
  boolean ? StringBoolean.TRUE : StringBoolean.FALSE;

export const isStringBoolean = (value: string): value is StringBoolean => {
  return value === StringBoolean.FALSE || value === StringBoolean.TRUE;
};
